export default {
  id: '__id__',
  display: '__display__',
}
